import { friendlyError } from '@/lib/errorCodes';

export function translateFarmsError(msg: string): string {
  // Mensagens amigáveis vindas diretamente de triggers do banco (regras de negócio)
  if (msg.includes('serviço(s) em aberto') || msg.includes('Máquinas insuficientes')
      || msg.includes('não pode mais ser editado') || msg.includes('telefone, CEP'))
    return msg.replace(/^.*?(Não é possível|Máquinas|Este orçamento|Não é permitido)/, '$1');
  if (msg.includes('row-level security') || msg.includes('RLS') || msg.includes('new row violates'))
    return 'Permissão insuficiente. Verifique se você está autenticado.';
  if (msg.includes('foreign key') || msg.includes('violates foreign key'))
    return 'Referência inválida. Recarregue a página e tente novamente.';
  if (msg.includes('duplicate') || msg.includes('unique'))
    return 'Este dado já foi cadastrado.';
  if (msg.includes('Failed to fetch') || msg.includes('NetworkError') || msg.includes('fetch'))
    return 'Erro de conexão. Verifique sua internet e tente novamente.';
  if (msg.includes('JWT') || msg.includes('token') || msg.includes('expired'))
    return 'Sessão expirada. Faça login novamente.';
  if (msg.includes('not found') || msg.includes('No rows'))
    return 'Registro não encontrado.';
  // Fallback com código de erro rastreável para o suporte
  return friendlyError(msg);
}
